module.exports = __webpack_public_path__ + "img/32.dc8bb8e8.jpg";